module.exports = __webpack_public_path__ + "static/img/shaping-the-future-of-education.29537356.jpg";